module.exports = __webpack_public_path__ + "static/media/Spend_Analysis2.787cf2ca.png";